module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALBAMAAABBvoqbAAAAIVBMVEUAAADDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8gFIQruAAAACnRSTlMAGtcSvsYe3cwx80RTrAAAACxJREFUCNdjmCLAwMDgpQgkLBYBmcxRakCm6fIEBgbGVQ5gFkgMLAtRB9YBAOf5CFy/N2P5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_next2_hover.png
// module id = LloL
// module chunks = 9